import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';

import {
    agentNotesSearchSchema,
    type AgentNotesTab,
} from '@apps/web/features/admin_agent_notes/model/search_params';
import { AgentNotesPage } from '@apps/web/features/admin_agent_notes/ui/agent_notes_page';

export const Route = createFileRoute('/_app/admin/agent-notes/')({
    component: AgentNotesRoute,
    validateSearch: agentNotesSearchSchema,
    head: () => ({
        meta: [{ title: 'Agent Notes | Phoebe Admin' }],
    }),
});

function AgentNotesRoute() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();

    const handleTabChange = useCallback(
        (tab: AgentNotesTab) => {
            void navigate({
                search: (prev) => ({ ...prev, tab }),
                replace: true,
            });
        },
        [navigate],
    );

    return <AgentNotesPage tab={search.tab} onTabChange={handleTabChange} />;
}
